import { worksData } from '../../data';
import './works.scss';
import WorksCarousel from './components/WorksCarousel';

const Works = () => {
	return (
		<div id='works'>
			<h2>Works</h2>
			<div className='slide-container'>
				<WorksCarousel data={worksData} />
			</div>
		</div>
	);
};

export default Works;
